import React, { useState, useContext } from 'react';
import { Marker, useMapEvents } from 'react-leaflet';
import { ProfileContext } from '../../services/profile/profile.context';

export const UserMarker = ({ center }) => {

  const [position, setPosition] = useState(center);
  const { setTempLocation } = useContext(ProfileContext);

  const map = useMapEvents({
    click: (e) => {
      setPosition(e.latlng); // 👈 add marker
      map.setView(e.latlng, map.getZoom());
      setTempLocation(e.latlng);
    },
  });

  return position === null ? null : <Marker position={position} />;
};

